/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { StructureElement } from '../../../../../mol-model/structure';
import { SortedRanges } from '../../../../../mol-data/int/sorted-ranges';
import { getGapRanges } from '../polymer';
/** Iterates over gaps, i.e. the stem residues/coarse elements adjacent to gaps */

export function PolymerGapIterator(structure, unit) {
  switch (unit.kind) {
    case 0
    /* Atomic */
    :
      return new AtomicPolymerGapIterator(structure, unit);

    case 1
    /* Spheres */
    :
    case 2
    /* Gaussians */
    :
      return new CoarsePolymerGapIterator(structure, unit);
  }
}

function createPolymerGapPair(structure, unit) {
  return {
    centerA: StructureElement.Location.create(structure, unit),
    centerB: StructureElement.Location.create(structure, unit)
  };
}

var AtomicPolymerGapIterator =
/** @class */
function () {
  function AtomicPolymerGapIterator(structure, unit) {
    this.unit = unit;
    this.hasNext = false;
    this.traceElementIndex = unit.model.atomicHierarchy.derived.residue.traceElementIndex; // can assume it won't be -1 for polymer residues

    this.gapIt = SortedRanges.transientSegments(getGapRanges(unit), unit.elements);
    this.value = createPolymerGapPair(structure, unit);
    this.hasNext = this.gapIt.hasNext;
  }

  AtomicPolymerGapIterator.prototype.move = function () {
    var _a = this.unit,
        elements = _a.elements,
        residueIndex = _a.residueIndex;
    var gapSegment = this.gapIt.move();
    this.value.centerA.element = this.traceElementIndex[residueIndex[elements[gapSegment.start]]];
    this.value.centerB.element = this.traceElementIndex[residueIndex[elements[gapSegment.end - 1]]];
    this.hasNext = this.gapIt.hasNext;
    return this.value;
  };

  return AtomicPolymerGapIterator;
}();

export { AtomicPolymerGapIterator };

var CoarsePolymerGapIterator =
/** @class */
function () {
  function CoarsePolymerGapIterator(structure, unit) {
    this.unit = unit;
    this.hasNext = false;
    this.gapIt = SortedRanges.transientSegments(getGapRanges(unit), unit.elements);
    this.value = createPolymerGapPair(structure, unit);
    this.hasNext = this.gapIt.hasNext;
  }

  CoarsePolymerGapIterator.prototype.move = function () {
    var gapSegment = this.gapIt.move();
    this.value.centerA.element = this.unit.elements[gapSegment.start];
    this.value.centerB.element = this.unit.elements[gapSegment.end - 1];
    this.hasNext = this.gapIt.hasNext;
    return this.value;
  };

  return CoarsePolymerGapIterator;
}();

export { CoarsePolymerGapIterator };